import script from "./InvoicePaymentsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoicePaymentsSection.vue?vue&type=script&setup=true&lang=js"

import "./InvoicePaymentsSection.vue?vue&type=style&index=0&id=863091a0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-863091a0"]])

export default __exports__